import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import pako from 'pako';
import { Observable } from 'rxjs';

import { UrlParametersService } from 'src/app/services/urlParameters/url-parameters.service';
import {
  DEFAULT_URL_COUNTRY_CODE,
  DEFAULT_URL_COUNTRY_NAME,
  DEFAULT_URL_LOCALE
} from 'src/app/shared/constants/defaultUrlParams.enum';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  private compressedApiRequestParts: string[] = ['content/query'];

  constructor(
    private parametersService: UrlParametersService
  ) {}

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const { queryParams } = this.parametersService;
    const locale = request.params.get('locale') || queryParams.locale;
    const countryName = request.params.get('countryName') || queryParams.countryName;
    const countryCode = request.params.get('countryCode') || queryParams.countryCode;

    if (!(locale && countryName && countryCode)) {
      console.warn('No required params, see ApiInterceptor', queryParams);
    }

    const setParams: { [param: string]: string } = {
      locale: locale && locale !== 'undefined' ? locale : DEFAULT_URL_LOCALE,
      culture: locale && locale !== 'undefined' ? locale : DEFAULT_URL_LOCALE,
      countryName: countryName && countryName !== 'undefined' ? countryName : DEFAULT_URL_COUNTRY_NAME,
      countryCode: countryCode && countryCode !== 'undefined' ? countryCode : DEFAULT_URL_COUNTRY_CODE
    };
    const forcedToggleStatesParameterKey = 'force_toggle_states';
    const forcedToggleStates: string =
      request.params.get(forcedToggleStatesParameterKey) ||
      queryParams[forcedToggleStatesParameterKey];

    if (forcedToggleStates) {
      setParams[forcedToggleStatesParameterKey] = forcedToggleStates;
    }

    let headers = request.headers;
    headers = headers.set('Content-Type', 'application/vnd.regus.ecom.contentqueryrequest+json')
      .set('Accept', 'application/vnd.regus.ecom.contentsimpleresponse+json');
    const isCompressedQuery = this.compressedApiRequestParts.some(part => request.url.includes(part));
    if (isCompressedQuery) {
      headers = headers.set('Content-Encoding', 'gzip');
    }
    const advancedReq = request.clone({
      setParams,
      headers: headers,
      ...(isCompressedQuery ? { body: pako.gzip(JSON.stringify(request.body)).buffer } : {})
    });
    return next.handle(advancedReq);
  }
}
